import React, { useState } from 'react';
import SliderButton from '@components/position/jd/common/SliderButton';
import PositionBookmarkListItem from '@components/common/positionBookmarkListItem';
import { PositionBookmarkListItemVO } from '@domain/vo/common/PositionBookmarkListItemVO';

import classnames from 'classnames/bind';
import styles from './jobList.module.scss';
const cx = classnames.bind(styles);

interface JobListProps {
  positions: PositionBookmarkListItemVO[];
}

const JobList = ({ positions }: JobListProps) => {
  const [positionIndex, setPositionIndex] = useState(0);
  // 마지막 요소의 이동 크기
  const [lastMove, setLastMove] = useState(0);
  // 이동되는 크기(카드(294) + 여백(24))
  const moveOffset = 318;
  // 보여지는 갯수
  const viewCount = 2;
  const isPrev = positionIndex > 0;
  const isNext = positionIndex < positions.length - viewCount;

  const handlePrev = () => {
    if (lastMove !== 0) {
      setLastMove(0);
    }

    setPositionIndex(positionIndex - 1);
  };

  const handleNext = () => {
    if (positionIndex === positions.length - viewCount - 1) {
      // 이동되는 크기(306) - 마지막 요소 안보이는 부분(134)
      setLastMove(172);
    }

    setPositionIndex(positionIndex + 1);
  };

  const positionEls = positions?.map((positionJob, idx) => {
    return (
      <li className={cx('listItem')} key={idx}>
        {/* isJD 리사이징 */}
        <PositionBookmarkListItem index={idx} data={positionJob} isBookmarkVisible isJD={true} />
      </li>
    );
  });

  return (
    <div className={cx('similarPositionListArea')}>
      <SliderButton visible={isPrev} type={'prev'} handleClick={handlePrev} top={86} />
      <div className={cx('similarPositionListWrap')}>
        <ul
          style={{ transform: `translateX(${-positionIndex * moveOffset + lastMove}px)` }}
          className={cx('similarPositionList')}
        >
          {positionEls}
        </ul>
      </div>
      <SliderButton visible={isNext} type={'next'} handleClick={handleNext} top={86} />
    </div>
  );
};

export default JobList;
